import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './index.css';
import App from './App';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { migrateLegacyStorageKeys } from './utils/migrateLegacyStorageKeys';
import { reloadOnStaleChunk } from './utils/reloadOnStaleChunk';

// One-shot rebrand migration: move persisted prefs off the old Pipeline Pilot
// storage prefixes before any hook reads them. Idempotent.
migrateLegacyStorageKeys();
reloadOnStaleChunk();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <CurrencyProvider>
        <ThemeContextProvider>
          <App />
        </ThemeContextProvider>
      </CurrencyProvider>
    </AuthProvider>
  </React.StrictMode>
);
